exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".demo-base[data-v-3260e836]{display:flex}@media (max-width:767px){.demo-base[data-v-3260e836]{display:block}.demo-base>div[data-v-3260e836]{margin-left:0;margin-top:20px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3260e836","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/demo-base/demo-base.vue
// module id = 128
// module chunks = 0